import { render, staticRenderFns } from "./WizardLayout.vue?vue&type=template&id=4b0cbc89&"
import script from "./WizardLayout.vue?vue&type=script&lang=js&"
export * from "./WizardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports